import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-working-capital',
  templateUrl: './working-capital.component.html',
  styleUrls: ['./working-capital.component.scss']
})
export class WorkingCapitalComponent implements OnInit {

  constructor(
    private router: Router
  ) {

    let status = localStorage.getItem('has_onboarded')
    if (status == 'false') {
      this.router.navigate(['/onboarding'])
    }
    else {
      return
    }
    
  }

  ngOnInit() {
  }

}
